import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import WarehouseForm from './components/WarehouseForm';
import UrlCreator from './components/UrlCreator';
import SessionCheckout from './checkout-session/SessionCheckout';
import { LocalizationProvider, useLocalization } from './localization/LocalizationContext';
import { Language } from './localization/translations';
import './App.css';

const LanguageSwitcher: React.FC = () => {
  const { language, changeLanguage } = useLocalization();

  const toggleLanguage = () => {
    const newLanguage: Language = language === 'uk' ? 'en' : 'uk';
    changeLanguage(newLanguage);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="px-3 py-1 rounded-md bg-gray-200 hover:bg-gray-300 text-sm font-medium transition-colors duration-200"
    >
      {language === 'uk' ? 'EN' : 'UA'}
    </button>
  );
};

const AppContent: React.FC = () => {
  const { t } = useLocalization();

  return (
    <div className="min-h-screen w-full bg-white flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-sm py-4 sticky top-0 z-10">
        <div className="container mx-auto px-4 md:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-custom-pink">{t.appName}</h1>
              <img
                src="/images/kvitka.png"
                alt="Kvitka"
                className="h-8 ml-2"
              />
            </div>
            <div className="flex items-center space-x-4">
              <div className="text-gray-600"></div>
              <LanguageSwitcher />
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 py-6">
          <Routes>
            <Route path="/" element={<WarehouseForm />} />
            <Route path="/c/:sessionId" element={<SessionCheckout />} />
            <Route path="/urlcreator" element={<UrlCreator />} />
          </Routes>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white shadow-inner py-3 mt-auto">
        <div className="container mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center text-gray-500 text-sm">
            {t.footer.copyright.replace('{year}', new Date().getFullYear().toString())}
          </div>
        </div>
      </footer>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <LocalizationProvider>
      <Router>
        <AppContent />
      </Router>
    </LocalizationProvider>
  );
};

export default App;
